module.exports = __webpack_public_path__ + "img/suggest-learn-yellow.c2efff59.png";